<template>
  <div class="pa-3 ma-3">
    <v-alert-dialog ref="alert"></v-alert-dialog>

    <!-- Diálogo Crear/Editar Puesto -->
    <v-dialog max-width="70%" v-model="dialogAddEdit" persistent>
      <v-card v-if="loadingDetails">
        <v-card-title>
          Editar Puesto
        </v-card-title>

        <v-card-text class="text-center py-8">
          <v-progress-circular
            indeterminate
            size="128"
            width="4"
            class="mb-3"
            color="primary"
          ></v-progress-circular>
          <div class="text-subtitle-2">
            Cargando detalles del puesto...
          </div>
        </v-card-text>
      </v-card>

      <v-card v-else>
        <v-card-title>
          {{ editedItem.id_puesto === null ? "Crear" : "Editar" }} Puesto
        </v-card-title>

        <v-card-text>
          <v-row>
            <v-col cols="12" class="pa-0 ma-0 text-center">
              <br />
              <div class="text-subtitle-1 font-weight-bold">
                <v-icon>mdi-information-outline</v-icon>
                Información General
              </div>
              <br />
            </v-col>

            <!-- Línea ya existente -->
            <v-col cols="12" md="6">
              <v-text-field
                v-model="editedItem.nombre"
                label="Nombre del puesto"
                outlined
                dense
                hide-details
                counter="128"
              />
            </v-col>

            <v-col cols="12" md="6">
              <v-autocomplete
                v-model="editedItem.id_rh_area"
                :items="area_puestos"
                item-value="id_rh_area"
                item-text="nombre"
                label="Tipo de Puesto"
                outlined
                dense
                hide-details
                :menu-props="{ maxHeight: 300 }"
              />
            </v-col>

            <v-col cols="12" md="6" class="d-flex align-center">
              <v-checkbox
                v-model="editedItem.puede_solicitar_vacantes"
                label="Puede realizar solicitudes de vacantes"
                hide-details
                dense
              />
            </v-col>

            <!-- ──────────────────────────────────────────────────────────── -->
            <!-- NUEVOS CAMPOS (1–7)                                         -->
            <!-- ──────────────────────────────────────────────────────────── -->

            <!-- 1. Régimen de contratación -->
            <v-col cols="12" md="6">
              <v-autocomplete
                v-model="editedItem.ids_contratacion_regimen"
                :items="regimen_contratacion"
                item-text="nombre"
                item-value="id_contratacion_regimen"
                label="Régimen de contratación"
                outlined
                dense
                hide-details
                multiple
                chips
                deletable-chips
                small-chips
              />
            </v-col>

            <!-- 2. Código SGC UBGA -->
            <v-col cols="12" md="6">
              <v-text-field
                v-model="editedItem.codigo_sgc"
                label="Código SGC UBGA"
                outlined
                dense
                hide-details
                counter="64"
              />
            </v-col>

            <!-- 3. No. revisión -->
            <v-col cols="12" md="6">
              <v-text-field
                v-model="editedItem.no_revision"
                label="No. revisión"
                outlined
                dense
                hide-details
                counter="32"
              />
            </v-col>

            <!-- 4. Fecha emisión -->
            <v-col cols="12" md="6">
              <v-menu
                v-model="menu.fecha_emision"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="editedItem.fecha_emision"
                    label="Fecha emisión"
                    readonly
                    outlined
                    dense
                    hide-details
                    v-bind="attrs"
                    v-on="on"
                    :rules="[rules.required]"
                  />
                </template>
                <v-date-picker
                  v-model="editedItem.fecha_emision"
                  @input="menu.fecha_emision = false"
                  scrollable
                />
              </v-menu>
            </v-col>

            <!-- 5. ¿Qué tipo de puesto es? -->
            <v-col cols="12" md="6">
              <v-autocomplete
                v-model="editedItem.id_puesto_tipo"
                :items="tipo_puesto"
                item-value="id_puesto_tipo"
                item-text="nombre"
                label="¿Qué tipo de puesto es?"
                outlined
                dense
                hide-details
              />
            </v-col>

            <!-- 7. Documento de autorización (PDF) -->
            <v-col cols="12">
              <v-file-input-plus
                :urlBase="urlBase"
                dense
                accept=".pdf"
                :max-size="5242880"
                hide-details
                outlined
                label="Inserta el documento de autorización de puesto (PDF)"
                v-model="archivo_autorizacion_pdf"
              ></v-file-input-plus>
            </v-col>

            <v-col cols="12" class="pa-0 ma-0 text-center">
              <br />
              <div class="text-subtitle-1 font-weight-bold">
                <v-icon>mdi-account-multiple-outline</v-icon>
                Relaciones jerárquicas y Jornada Laboral
              </div>
              <br />
            </v-col>

            <!-- ──────────────────────────────────────────────────────────── -->
            <!-- RELACIONES (8–9)                                            -->
            <!-- ──────────────────────────────────────────────────────────── -->

            <!-- 8. Puesto al que reporta -->
            <v-col cols="12">
              <v-autocomplete
                v-model="editedItem.id_puesto_reporta_a"
                :items="listaPuestosSelect"
                item-value="id_puesto"
                item-text="nombre"
                label="Puesto al que reporta"
                outlined
                dense
                hide-details
                :menu-props="{ maxHeight: 300 }"
                clearable
              />
            </v-col>

            <!-- 9. Puestos que le reportan -->
            <v-col cols="12">
              <v-autocomplete
                v-model="editedItem.ids_puestos_le_reportan"
                :items="listaPuestosSelect"
                item-value="id_puesto"
                item-text="nombre"
                label="Puestos que le reportan"
                multiple
                chips
                deletable-chips
                outlined
                hide-details
                :menu-props="{ maxHeight: 300 }"
                clearable
                small-chips
              />
            </v-col>

            <!-- ──────────────────────────────────────────────────────────── -->
            <!-- UBICACIÓN Y HORARIOS (10–14)                                 -->
            <!-- ──────────────────────────────────────────────────────────── -->

            <!-- 10. Lugar de trabajo -->
            <v-col cols="12" md="6" style="align-self: center">
              <v-text-field
                v-model="editedItem.lugar_trabajo"
                label="Lugar de trabajo"
                outlined
                dense
                hide-details
                counter="128"
              />
            </v-col>

            <!-- 11. Días de trabajo -->
            <v-col cols="12" md="6">
              <div class="mb-1 caption grey--text">Días de trabajo</div>
              <div class="d-flex flex-wrap" style="gap: 6px">
                <v-btn
                  v-for="d in dias_semana"
                  :key="d.value"
                  small
                  :outlined="!editedItem.dias_trabajo.includes(d.value)"
                  :depressed="editedItem.dias_trabajo.includes(d.value)"
                  @click="toggleDia(d.value)"
                  color="primary"
                >
                  {{ d.text }}
                </v-btn>
              </div>
            </v-col>

            <!-- 12. Jornada laboral diaria (horas) -->
            <v-col cols="12" md="4">
              <v-text-field
                v-model.number="editedItem.jornada_horas"
                label="Jornada laboral diaria (horas)"
                outlined
                dense
                hide-details
                type="number"
                min="0"
                step="0.5"
                :rules="[rules.numberNonNegative]"
              />
            </v-col>

            <!-- 13. Hora entrada -->
            <v-col cols="12" md="4">
              <v-menu
                v-model="menu.hora_entrada"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290"
                min-width="290"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="editedItem.hora_entrada"
                    label="Hora entrada"
                    readonly
                    outlined
                    dense
                    hide-details
                    v-bind="attrs"
                    v-on="on"
                  />
                </template>
                <v-time-picker
                  v-model="editedItem.hora_entrada"
                  format="24hr"
                  @change="menu.hora_entrada = false"
                />
              </v-menu>
            </v-col>

            <!-- 14. Hora salida -->
            <v-col cols="12" md="4">
              <v-menu
                v-model="menu.hora_salida"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290"
                min-width="290"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="editedItem.hora_salida"
                    label="Hora salida"
                    readonly
                    outlined
                    dense
                    hide-details
                    v-bind="attrs"
                    v-on="on"
                  />
                </template>
                <v-time-picker
                  v-model="editedItem.hora_salida"
                  format="24hr"
                  @change="menu.hora_salida = false"
                />
              </v-menu>
            </v-col>

            <v-col cols="12" class="pa-0 ma-0 text-center">
              <br />
              <div class="text-subtitle-1 font-weight-bold">
                <v-icon>mdi-forum-outline</v-icon>
                Comunicación
              </div>
              <br />
            </v-col>

            <!-- ──────────────────────────────────────────────────────────── -->
            <!-- LISTAS EDITABLES DE TEXTO (15–19, 40, 42)                    -->
            <!-- Usamos v-combobox multiple para rápida captura libre         -->
            <!-- ──────────────────────────────────────────────────────────── -->

            <!-- 15. Contactos internos -->
            <v-col cols="12">
              <v-autocomplete
                v-model="editedItem.contactos_internos"
                :items="listaPuestosSelect"
                item-value="id_puesto"
                item-text="nombre"
                label="Contactos internos"
                outlined
                hide-details
                clearable
                multiple
                chips
                deletable-chips
                small-chips
              />
            </v-col>

            <!-- 16. Contactos externos -->
            <v-col cols="12">
              <v-table-text
                v-model="editedItem.contactos_externos"
                titulo="Contactos Externos"
                item-name="Contacto externo"
              />
            </v-col>

            <v-col cols="12" class="pa-0 ma-0 text-center">
              <br />
              <div class="text-subtitle-1 font-weight-bold">
                <v-icon>mdi-target</v-icon>
                Objetivos y funciones
              </div>
              <br />
            </v-col>

            <!-- 17. Objetivo del puesto -->
            <v-col cols="12">
              <v-textarea
                v-model="editedItem.objetivo"
                label="Objetivo del puesto"
                outlined
                dense
                hide-details
                :rows="1"
                auto-grow
              />
            </v-col>

            <!-- 18. Funciones del puesto -->
            <v-col cols="12">
              <v-table-text
                v-model="editedItem.funciones"
                titulo="Funciones"
                item-name="Función"
              />
            </v-col>

            <!-- 19. Responsabilidades del puesto -->
            <v-col cols="12">
              <v-table-text
                v-model="editedItem.responsabilidades"
                titulo="Responsabilidades del puesto"
                item-name="Responsabilidad del puesto"
              />
            </v-col>

            <v-col cols="12" class="pa-0 ma-0 text-center">
              <br />
              <div class="text-subtitle-1 font-weight-bold">
                <v-icon>mdi-briefcase-outline</v-icon>
                Requisitos y Experiencia
              </div>
              <br />
            </v-col>

            <!-- ──────────────────────────────────────────────────────────── -->
            <!-- REQUISITOS ACADÉMICOS E IDIOMAS (20–31)                      -->
            <!-- ──────────────────────────────────────────────────────────── -->

            <!-- 20. Escolaridad -->
            <v-col cols="12">
              <v-autocomplete
                v-model="editedItem.id_rh_escolaridad"
                :items="escolaridad"
                item-value="id_rh_escolaridad"
                item-text="nombre"
                label="Escolaridad"
                outlined
                dense
                hide-details
              />
            </v-col>

            <!-- 21. Área (condicional) -->
            <v-col cols="12">
              <v-table-text
                v-if="mostrarAreaLicenciatura"
                v-model="editedItem.escolaridad_area"
                titulo="A partir de licenciatura, indique el área"
                item-name="Área"
              />
            </v-col>

            <!-- 22. Experiencia requerida -->
            <v-col cols="12">
              <v-table-text
                v-model="editedItem.experiencia_requerida"
                titulo="Experiencia requerida"
                item-name="Experiencia requerida"
              />
            </v-col>

            <v-col cols="12">
              <div class="subtitle-2 mb-1">Idiomas</div>
              <v-simple-table dense class="mb-2">
                <thead>
                  <tr>
                    <th class="text-left" style="width: 45%">Idioma</th>
                    <th class="text-left" style="width: 45%">
                      Nivel de dominio
                    </th>
                    <th style="width: 10%"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(row, i) in editedItem.idiomas"
                    :key="'idioma-' + i"
                  >
                    <td style="width: 45%">
                      <v-autocomplete
                        v-model="row.id_rh_idioma"
                        :items="idiomas"
                        item-value="id_rh_idioma"
                        item-text="nombre"
                        label="Idioma"
                        outlined
                        dense
                        hide-details
                        class="my-2"
                      />
                    </td>
                    <td style="width: 45%">
                      <v-autocomplete
                        v-model="row.id_rh_idioma_nivel"
                        :items="nivel_idioma"
                        item-value="id_rh_idioma_nivel"
                        item-text="nombre"
                        label="Grado dominio idioma"
                        outlined
                        dense
                        hide-details
                      />
                    </td>
                    <td class="text-center" style="width: 10%">
                      <v-btn icon small @click="removeIdioma(i)">
                        <v-icon small>mdi-delete</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>
              <v-btn small outlined @click="addIdioma">
                <v-icon left small>mdi-plus</v-icon>Agregar idioma
              </v-btn>
            </v-col>

            <!-- ──────────────────────────────────────────────────────────── -->
            <!-- VIAJES Y LICENCIA (32–37)                                    -->
            <!-- ──────────────────────────────────────────────────────────── -->

            <!-- 32. ¿Requiere viajar? -->
            <v-col cols="12" md="4">
              <v-autocomplete
                v-model="editedItem.requiere_viajar"
                :items="si_no"
                label="¿Requiere viajar?"
                outlined
                dense
                hide-details
              />
            </v-col>

            <!-- 33. Motivo de viaje (multiple) -->
            <v-col cols="12" md="8">
              <v-autocomplete
                v-model="editedItem.ids_rh_viaje_motivos"
                :items="motivo_viaje"
                item-value="id_rh_viaje_motivo"
                item-text="nombre"
                label="Motivo de viaje"
                multiple
                chips
                deletable-chips
                outlined
                dense
                hide-details
              />
            </v-col>

            <!-- 34. Periodicidad del viaje -->
            <v-col cols="12" md="4">
              <v-autocomplete
                v-model="editedItem.id_rh_viaje_periodicidad"
                :items="periodicidad_viaje"
                item-value="id_rh_viaje_periodicidad"
                item-text="nombre"
                label="Periodicidad del viaje"
                outlined
                dense
                hide-details
              />
            </v-col>

            <!-- 35. ¿A dónde? -->
            <v-col cols="12" md="8">
              <v-autocomplete
                v-model="editedItem.ids_rh_viaje_destino"
                :items="destinos_viaje"
                item-value="id_rh_viaje_destino"
                item-text="nombre"
                label="¿A dónde?"
                multiple
                chips
                deletable-chips
                outlined
                dense
                hide-details
              />
            </v-col>

            <!-- 36. ¿Requiere licencia de conducir? -->
            <v-col cols="12" md="4">
              <v-autocomplete
                v-model="editedItem.requiere_licencia"
                :items="si_no"
                label="¿Requiere licencia de conducir?"
                outlined
                dense
                hide-details
              />
            </v-col>

            <!-- 37. ¿Qué tipo? (licencia) -->
            <v-col cols="12" md="8">
              <v-autocomplete
                v-model="editedItem.id_rh_conducir_licencia_tipo"
                :items="tipo_licencia_conducir"
                item-value="id_rh_conducir_licencia_tipo"
                item-text="nombre"
                label="¿Qué tipo?"
                outlined
                dense
                hide-details
                :disabled="editedItem.requiere_licencia !== true"
              />
            </v-col>

            <!-- ──────────────────────────────────────────────────────────── -->
            <!-- CONOCIMIENTOS (38–39)                                        -->
            <!-- ──────────────────────────────────────────────────────────── -->

            <v-col cols="12">
              <div class="subtitle-2 mb-1">Conocimientos Requeridos</div>
              <v-simple-table dense class="mb-2">
                <thead>
                  <tr>
                    <th class="text-left" style="width: 60%">Conocimiento</th>
                    <th class="text-left" style="width: 30%">
                      Nivel de dominio
                    </th>
                    <th style="width: 10%"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(row, i) in editedItem.conocimientos_requeridos"
                    :key="'cono-' + i"
                  >
                    <td style="width: 60%">
                      <v-text-field
                        v-model="row.conocimiento"
                        dense
                        outlined
                        hide-details
                        class="my-2"
                      />
                    </td>
                    <td style="width: 30%">
                      <v-autocomplete
                        v-model="row.id_rh_conocimiento_dominio_nivel"
                        :items="nivel_conocimientos"
                        item-value="id_rh_conocimiento_dominio_nivel"
                        item-text="nombre"
                        label="Nivel de dominio"
                        outlined
                        dense
                        hide-details
                        class="my-2"
                      />
                    </td>
                    <td class="text-center" style="width: 10%">
                      <v-btn icon small @click="removeConocimiento(i)">
                        <v-icon small>mdi-delete</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>
              <v-btn small outlined @click="addConocimiento">
                <v-icon left small>mdi-plus</v-icon>Agregar conocimiento
              </v-btn>
            </v-col>

            <!-- ──────────────────────────────────────────────────────────── -->
            <!-- COMPETENCIAS (41)                                            -->
            <!-- ──────────────────────────────────────────────────────────── -->
            <v-col cols="12">
              <div class="subtitle-2 mb-1">Competencias organizacionales</div>
              <v-simple-table dense class="mb-2">
                <thead>
                  <tr>
                    <th class="text-left" style="width: 60%">Competencia</th>
                    <th class="text-left" style="width: 30%">Nivel (1–4)</th>
                    <th style="width: 10%"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(row, i) in editedItem.competencias"
                    :key="'comp-' + i"
                  >
                    <td>
                      <v-text-field
                        v-model="row.competencia"
                        dense
                        outlined
                        hide-details
                        class="my-2"
                      />
                    </td>
                    <td>
                      <v-text-field
                        v-model="row.nivel"
                        type="number"
                        min="1"
                        max="4"
                        dense
                        outlined
                        hide-details
                        :rules="[rules.level1to4]"
                        class="my-2"
                      />
                    </td>
                    <td class="text-center">
                      <v-btn icon small @click="removeCompetencia(i)">
                        <v-icon small>mdi-delete</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>
              <v-btn small outlined @click="addCompetencia">
                <v-icon left small>mdi-plus</v-icon>Agregar competencia
              </v-btn>
            </v-col>

            <v-col cols="12" class="pa-0 ma-0 text-center">
              <br />
              <div class="text-subtitle-1 font-weight-bold">
                <v-icon>mdi-laptop</v-icon>
                Resguardo de Activos
              </div>
              <br />
            </v-col>

            <v-col cols="12">
              <v-simple-table dense class="mb-2">
                <thead>
                  <tr>
                    <th class="text-left" style="width: 60%">Equipo</th>
                    <th class="text-left" style="width: 30%">Cantidad</th>
                    <th style="width: 10%"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(row, i) in editedItem.equipo_resguardo"
                    :key="'equipo-' + i"
                  >
                    <td>
                      <v-autocomplete
                        v-model="row.id_resguardo_subtipo"
                        :items="equipo_resguardo"
                        item-value="id_resguardo_subtipo"
                        item-text="nombre"
                        dense
                        outlined
                        hide-details
                        class="my-2"
                      />
                    </td>
                    <td>
                      <v-text-field
                        v-model="row.cantidad"
                        type="number"
                        min="1"
                        max="4"
                        dense
                        outlined
                        hide-details
                        :rules="[rules.level1to4]"
                        class="my-2"
                      />
                    </td>
                    <td class="text-center">
                      <v-btn icon small @click="removeEquipo(i)">
                        <v-icon small>mdi-delete</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>
              <v-btn small outlined @click="addEquipo">
                <v-icon left small>mdi-plus</v-icon>Agregar Equipo
              </v-btn>
            </v-col>

            <v-col cols="12" md="6" class="d-flex align-center">
              <v-checkbox
                v-model="editedItem.correo_institucional"
                label="Correo Institucional"
                hide-details
                dense
              />
            </v-col>

            <v-col cols="12" class="pa-0 ma-0 text-center">
              <br />
              <div class="text-subtitle-1 font-weight-bold">
                <v-icon>mdi-chart-line</v-icon>
                KPI's
              </div>
              <br />
            </v-col>

            <!-- ──────────────────────────────────────────────────────────── -->
            <!-- KPI's (42)                                                   -->
            <!-- ──────────────────────────────────────────────────────────── -->
            <v-col cols="12">
              <v-simple-table dense class="mb-2">
                <thead>
                  <tr>
                    <th class="text-left" style="width: 20%">
                      Nombre del Indicador
                    </th>
                    <th class="text-left" style="width: 21%">Fórmula</th>
                    <th class="text-left" style="width: 16%">Meta</th>
                    <th class="text-left" style="width: 16%">Periodicidad</th>
                    <th class="text-left" style="width: 20%">
                      Medio de Verificación
                    </th>
                    <th style="width: 7%"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, i) in editedItem.kpis" :key="'kpi-' + i">
                    <td>
                      <v-text-field
                        v-model="row.nombre"
                        dense
                        outlined
                        hide-details
                        class="my-2"
                      />
                    </td>
                    <td>
                      <v-text-field
                        v-model="row.formula"
                        dense
                        outlined
                        hide-details
                        class="my-2"
                      />
                    </td>
                    <td>
                      <v-autocomplete
                        v-model="row.meta"
                        :items="tipo_kpi"
                        dense
                        outlined
                        hide-details
                        class="my-2"
                      />
                    </td>
                    <td>
                      <v-autocomplete
                        v-model="row.id_rh_kpi_periodicidad"
                        :items="periodicidad"
                        item-value="id_rh_kpi_periodicidad"
                        item-text="nombre"
                        dense
                        outlined
                        hide-details
                        class="my-2"
                      />
                    </td>
                    <td>
                      <v-text-field
                        v-model="row.medio_verificacion"
                        dense
                        outlined
                        hide-details
                        class="my-2"
                      />
                    </td>
                    <td class="text-center">
                      <v-btn icon small @click="removeKpi(i)">
                        <v-icon small>mdi-delete</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>
              <v-btn small outlined @click="addKpi">
                <v-icon left small>mdi-plus</v-icon>Agregar KPI
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn color="green" text @click="closeDialogAddEdit">Cancelar</v-btn>
          <v-btn
            color="red"
            text
            :loading="loading_save"
            @click="saveDialogAddEdit"
          >
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Diálogo Eliminar -->
    <v-dialog max-width="600px" v-model="dialogDelete" persistent>
      <v-card>
        <v-card-title>Eliminar Puesto</v-card-title>
        <v-card-text>
          ¿Eliminar el puesto "<strong>{{ editedItem.nombre }}</strong
          >"? Esta acción es permanente.
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="green" text @click="closeDialogDelete">Cancelar</v-btn>
          <v-btn
            color="red"
            text
            :loading="loading_delete"
            @click="saveDialogDelete"
          >
            Eliminar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- NUEVO: Diálogo Requisitos como componente hijo -->
    <puesto-requisitos-dialog
      v-model="requisitosDialogOpen"
      :puesto="editedItem"
      :tipoPuestos="tipoPuestos"
      :loading="loadingRequisitosDialogOpen || loadingRequirements"
      @close="getItems"
    />

    <!-- Barra de acciones -->
    <v-row>
      <v-col cols="6" class="d-flex align-center" style="gap: 8px">
        <v-btn color="primary" @click="openDialogAddEdit(null)"
          >Crear Puesto</v-btn
        >
      </v-col>

      <v-col cols="6">
        <v-text-field
          v-model="searchInput"
          label="Buscar"
          clearable
          dense
          hide-details
        ></v-text-field>
      </v-col>
    </v-row>

    <!-- Tabla Puestos -->
    <v-row>
      <v-col cols="12">
        <v-data-table
          :items="items"
          :headers="headers"
          :loading="loading"
          item-key="id_puesto"
          :search="searchInput"
        >
          <template v-slot:[`item.puede_solicitar_vacantes`]="{ item }">
            <v-icon
              small
              :color="item.puede_solicitar_vacantes ? 'green' : 'grey'"
              :title="item.puede_solicitar_vacantes ? 'Sí' : 'No'"
            >
              {{
                item.puede_solicitar_vacantes
                  ? "mdi-check-circle"
                  : "mdi-close-circle"
              }}
            </v-icon>
            <span class="ml-1">{{
              item.puede_solicitar_vacantes ? "Sí" : "No"
            }}</span>
          </template>

          <template v-slot:[`item.actions`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  small
                  class="mr-2"
                  v-bind="attrs"
                  v-on="on"
                  @click="openDialogAddEdit(item)"
                  >mdi-pencil</v-icon
                >
              </template>
              <span>Editar</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  small
                  class="mr-2"
                  v-bind="attrs"
                  v-on="on"
                  @click="openDialogDelete(item)"
                  >mdi-delete</v-icon
                >
              </template>
              <span>Eliminar</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  small
                  class="mr-2"
                  v-bind="attrs"
                  v-on="on"
                  @click="openDialogRequisitos(item)"
                  >mdi-file-document-edit</v-icon
                >
              </template>
              <span>Requisitos</span>
            </v-tooltip>
          </template>

          <template v-slot:no-data>
            <div class="text-center my-6">
              <div class="subtitle-1 mb-2">Sin datos</div>
              <v-btn small outlined @click="getItems">Recargar</v-btn>
            </div>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import axios from "axios";
import VAlertDialog from "@/components/VAlertDialog.vue";
// OJO: dejamos el import del hijo que ya tenías para requisitos del expediente (no lo tocamos)
import PuestoRequisitosDialog from "./Puestos/PuestoRequisitos.vue";
import VTableText from "@/components/VTableText.vue";
import VFileInputPlus from '@/components/VFileInputPlus.vue';

export default {
  name: "PuestosCrud",
  components: {
    VAlertDialog,
    PuestoRequisitosDialog,
    VTableText,
    VFileInputPlus
  },
  data: () => ({
    dialogAddEdit: false,
    dialogDelete: false,

    // diálogo hijo (no lo tocamos)
    requisitosDialogOpen: false,
    searchInput: '',
    loading: false,
    loading_save: false,
    loading_delete: false,

    // loading para requisitos hijo
    loadingRequisitosDialogOpen: false,

    items: [],
    tipoPuestos: [],
    headers: [
      { text: "Puesto", value: "nombre", align: "center", width: "35%" },
      {
        text: "Tipo de Puesto",
        value: "puesto_area",
        align: "center",
        width: "25%",
      },
      {
        text: "¿Puede solicitar vacantes?",
        value: "puede_solicitar_vacantes",
        align: "center",
        width: "15%",
      },
      {
        text: "Personas asignadas",
        value: "num_empleados_asignadas",
        align: "center",
        width: "15%",
      },
      { text: "Acciones", value: "actions", align: "center", width: "10%" },
    ],

    menu: {
      fecha_emision: false,
      hora_entrada: false,
      hora_salida: false,
    },

    //Catalogos
    regimen_contratacion: [],
    area_puestos: [],
    tipo_puesto: [],
    dias_semana: [
      { text: "Lun", value: 1 },
      { text: "Mar", value: 2 },
      { text: "Mié", value: 3 },
      { text: "Jue", value: 4 },
      { text: "Vie", value: 5 },
      { text: "Sáb", value: 6 },
      { text: "Dom", value: 0 },
    ],
    escolaridad: [],
    idiomas: [],
    nivel_idioma: [],
    si_no: [
      { text: "Si", value: true },
      { text: "No", value: false },
    ],
    motivo_viaje: [],
    periodicidad_viaje: [],
    tipo_licencia_conducir: [],
    nivel_conocimientos: [],
    destinos_viaje: [],
    tipo_kpi: [
      { text: "Entero", value: 1 },
      { text: "Porcentual", value: 2 },
    ],
    periodicidad: [],
    equipo_resguardo: [],

    // Validaciones simples
    rules: {
      required: (v) => !!v || "Requerido",
      numberNonNegative: (v) =>
        v === null || v === "" || Number(v) >= 0 || "Debe ser número ≥ 0",
      level1to4: (v) => (v >= 1 && v <= 4) || "Nivel 1–4",
      pdfOnly: (file) =>
        !file || (file && file.type === "application/pdf") || "Solo PDF",
    },

    archivo_autorizacion_pdf: null,

    editedItem: {
      id_puesto: null,
      nombre: null,
      id_rh_area: null,
      puede_solicitar_vacantes: false,
      ids_contratacion_regimen: [],
      codigo_sgc: null,
      no_revision: null,
      fecha_emision: null,
      id_puesto_tipo: null,
      id_puesto_reporta_a: null,
      ids_puestos_le_reportan: [],
      lugar_trabajo: null,
      jornada_horas: null,
      hora_entrada: null,
      hora_salida: null,
      contactos_internos: [],
      contactos_externos: [],
      objetivo: null,
      funciones: [],
      responsabilidades: [],
      id_rh_escolaridad: null,
      escolaridad_area: [],
      experiencia_requerida: [],
      requiere_viajar: null,
      ids_rh_viaje_motivos: [],
      id_rh_viaje_periodicidad: null,
      ids_rh_viaje_destino: [],
      requiere_licencia: null,
      id_rh_conducir_licencia_tipo: null,
      correo_institucional: false,
      idiomas: [],
      conocimientos_requeridos: [],
      competencias: [],
      equipo_resguardo: [],
      kpis: [],
      dias_trabajo: [],
      expediente_requisitos: [],
    },
    defaultEditedItem: {
      id_puesto: null,
      nombre: null,
      id_rh_area: null,
      puede_solicitar_vacantes: false,
      ids_contratacion_regimen: [],
      codigo_sgc: null,
      no_revision: null,
      fecha_emision: null,
      id_puesto_tipo: null,
      id_puesto_reporta_a: null,
      ids_puestos_le_reportan: [],
      lugar_trabajo: null,
      jornada_horas: null,
      hora_entrada: null,
      hora_salida: null,
      contactos_internos: [],
      contactos_externos: [],
      objetivo: null,
      funciones: [],
      responsabilidades: [],
      id_rh_escolaridad: null,
      escolaridad_area: [],
      experiencia_requerida: [],
      requiere_viajar: null,
      ids_rh_viaje_motivos: [],
      id_rh_viaje_periodicidad: null,
      ids_rh_viaje_destino: [],
      requiere_licencia: null,
      id_rh_conducir_licencia_tipo: null,
      correo_institucional: false,
      idiomas: [],
      conocimientos_requeridos: [],
      competencias: [],
      equipo_resguardo: [],
      kpis: [],
      dias_trabajo: [],
      expediente_requisitos: [],
    },
    saving: false,
    urlBase: "/api/RecursosHumanos/DescargarAutorizacion",

    loadingDetails: false,
    loadingRequirements: false
  }),

  computed: {
    listaPuestosSelect() {
      // Lista de puestos actuales para selects (8 y 9)
      return this.items?.length ? this.items : [];
    },
    mostrarAreaLicenciatura() {
      return (
        this.editedItem.id_rh_escolaridad ===
          "019a9355-c9ad-7012-8ba4-90c17206fb84" ||
        this.editedItem.id_rh_escolaridad ===
          "019a9355-e2f1-7c58-99db-560b2e5128a5"
      );
    },
    aplicaDocumentoAutorizacion() {
      // Solo para nuevos puestos o posiciones adicionales (criterio práctico: tipo_puesto === 'De nueva creación')
      return (
        this.editedItem.id_puesto_tipo ===
        "019a9353-06d0-7b9e-a322-ac4287efef20"
      );
    },
  },

  mounted() {
    this.getItems();

    //Catalogos
    this.getContratacionRegimenes();
    this.getRHAreas();
    this.getRHConducirLicenciaTipos();
    this.getRHConocimientoDominioNiveles();
    this.getRHEscolaridades();
    this.getRHIdiomaNiveles();
    this.getRHIdiomas();
    this.getRHKPIPeriodicidades();
    this.getRHViajeDestinos();
    this.getRHViajeMotivos();
    this.getRHViajePeriodicidades();
    this.getPuestoTipos();
    this.getResguardoSubtipos();
  },

  methods: {
    // =========================
    // Catalogos
    // =========================
    getContratacionRegimenes() {
      axios
        .get("/RHCatalogos/ListarContratacionRegimenes")
        .then((res) => {
          this.regimen_contratacion = res.data;
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {});
    },
    getRHAreas() {
      axios
        .get("/RHCatalogos/ListarRHAreas")
        .then((res) => {
          this.area_puestos = res.data;
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {});
    },
    getRHConducirLicenciaTipos() {
      axios
        .get("/RHCatalogos/ListarRHConducirLicenciaTipos")
        .then((res) => {
          this.tipo_licencia_conducir = res.data;
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {});
    },
    getRHConocimientoDominioNiveles() {
      axios
        .get("/RHCatalogos/ListarRHConocimientoDominioNiveles")
        .then((res) => {
          this.nivel_conocimientos = res.data;
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {});
    },
    getRHEscolaridades() {
      axios
        .get("/RHCatalogos/ListarRHEscolaridades")
        .then((res) => {
          this.escolaridad = res.data;
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {});
    },
    getRHIdiomaNiveles() {
      axios
        .get("/RHCatalogos/ListarRHIdiomaNiveles")
        .then((res) => {
          this.nivel_idioma = res.data;
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {});
    },
    getRHIdiomas() {
      axios
        .get("/RHCatalogos/ListarRHIdiomas")
        .then((res) => {
          this.idiomas = res.data;
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {});
    },
    getRHKPIPeriodicidades() {
      axios
        .get("/RHCatalogos/ListarRHKPIPeriodicidades")
        .then((res) => {
          this.periodicidad = res.data;
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {});
    },
    getRHViajeDestinos() {
      axios
        .get("/RHCatalogos/ListarRHViajeDestinos")
        .then((res) => {
          this.destinos_viaje = res.data;
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {});
    },
    getRHViajeMotivos() {
      axios
        .get("/RHCatalogos/ListarRHViajeMotivos")
        .then((res) => {
          this.motivo_viaje = res.data;
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {});
    },
    getRHViajePeriodicidades() {
      axios
        .get("/RHCatalogos/ListarRHViajePeriodicidades")
        .then((res) => {
          this.periodicidad_viaje = res.data;
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {});
    },
    getPuestoTipos() {
      axios
        .get("/RHCatalogos/ListarPuestoTipos")
        .then((res) => {
          this.tipo_puesto = res.data;
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {});
    },
    getResguardoSubtipos() {
      axios
      .get(`/RACatalogos/ListarResguardoSubtipos`)
      .then((res) => {
        let seen = new Set()

        // 1) Tipos únicos y ordenados
        let tipos = res.data
          .filter(x => {
            if (seen.has(x.id_resguardo_tipo)) return false
            seen.add(x.id_resguardo_tipo)
            return true
          })
          .map(x => ({
            id_resguardo_tipo: x.id_resguardo_tipo,
            tipo_nombre: x.tipo_nombre
          }))
          .sort((a, b) => a.tipo_nombre.localeCompare(b.tipo_nombre))

        // 2) Construimos el arreglo plano para Vuetify
        let data = []

        tipos.forEach(tipo => {
          // Header del tipo
          data.push({ header: tipo.tipo_nombre })

          // Subtipos de ese tipo
          const subtipos = res.data
            .filter(x => x.id_resguardo_tipo === tipo.id_resguardo_tipo)
            .map(x => ({
              id_resguardo_subtipo: x.id_resguardo_subtipo,
              nombre: x.nombre,
              // opcional: por si quieres mostrar el tipo también
              tipo_nombre: tipo.tipo_nombre
            }))

          // Importante: "aplanar" el array
          data.push(...subtipos)

          // Divider al final del grupo (si no quieres el último, luego hacemos un pop)
          data.push({ divider: true })
        })

        // Opcional: quitar el último divider
        if (data.length && data[data.length - 1].divider) {
          data.pop()
        }

        this.equipo_resguardo = data
      })
      .catch((err) => {
        console.log(err)
      })
      .finally(() => {
      })
    },

    // =========================
    // Funciones
    // =========================

    toggleDia(value) {
      const i = this.editedItem.dias_trabajo.indexOf(value);
      if (i === -1) this.editedItem.dias_trabajo.push(value);
      else this.editedItem.dias_trabajo.splice(i, 1);
    },

    addIdioma() {
      this.editedItem.idiomas.push({
        id_rh_idioma: null,
        id_rh_idioma_nivel: null,
      });
    },
    removeIdioma(i) {
      this.editedItem.idiomas.splice(i, 1);
    },

    addConocimiento() {
      this.editedItem.conocimientos_requeridos.push({
        conocimiento: null,
        id_rh_conocimiento_dominio_nivel: null,
      });
    },
    removeConocimiento(i) {
      this.editedItem.conocimientos_requeridos.splice(i, 1);
    },

    addCompetencia() {
      this.editedItem.competencias.push({ competencia: null, nivel: 1 });
    },
    removeCompetencia(i) {
      this.editedItem.competencias.splice(i, 1);
    },

    addEquipo() {
      this.editedItem.equipo_resguardo.push({
        id_resguardo_subtipo: null,
        cantidad: 1,
      });
    },
    removeEquipo(i) {
      this.editedItem.equipo_resguardo.splice(i, 1);
    },

    addKpi() {
      this.editedItem.kpis.push({
        nombre: "",
        formula: "",
        meta: null,
        id_rh_kpi_periodicidad: null,
        medio_verificacion: "",
      });
    },
    removeKpi(i) {
      this.editedItem.kpis.splice(i, 1);
    },

    onArchivoAutorizacionChange(file) {
      if (file && file.type !== "application/pdf") {
        this.$refs.alert.setMessage("", "El archivo debe ser PDF.");
        this.$refs.alert.open();
        this.archivo_autorizacion_pdf = null;
      }
    },

    getItems() {
      this.loading = true;

      axios
        .get("/RecursosHumanos/ListarPuestos")
        .then((response) => {
          this.items = response.data;
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // =========================
    // CRUD
    // =========================
    openDialogAddEdit(edit_item = null) {
      if (edit_item !== null){
        this.loadingDetails = true;
        this.dialogAddEdit = true;

        axios
        .get(`/RecursosHumanos/DetallePuesto/${edit_item.id_puesto}`)
        .then(response => {
          this.editedItem = response.data;
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.loadingDetails = false;
        })
      }

      else {
        this.editedItem = Object.assign({}, this.defaultEditedItem);
        this.dialogAddEdit = true;
      }

      

      if(edit_item == null){
        this.archivo_autorizacion_pdf = null;
      }
      else{
        this.archivo_autorizacion_pdf = edit_item.archivo_autorizacion_pdf;
      }
    },

    closeDialogAddEdit() {
      this.editedItem = Object.assign({}, this.defaultEditedItem);
      this.dialogAddEdit = false;
      this.archivo_autorizacion_pdf = null;
    },

    async saveDialogAddEdit() {
      // Validaciones mínimas
      if (
        !this.editedItem.nombre ||
        this.editedItem.nombre.trim().length === 0
      ) {
        this.$refs.alert.setMessage("", "Debes ingresar el nombre del puesto.");
        this.$refs.alert.open();
        return;
      }
      if (!this.editedItem.id_rh_area) {
        this.$refs.alert.setMessage(
          "",
          "Selecciona el Tipo de Puesto del puesto."
        );
        this.$refs.alert.open();
        return;
      }
      
      //if (
      //  this.aplicaDocumentoAutorizacion && (!this.archivo_autorizacion_pdf || this.archivo_autorizacion_pdf.length <= 0)
      //) {
      //  this.$refs.alert.setMessage(
      //    "",
      //    "Es necesario un documento de autorización en formato PDF."
      //  );
      //  this.$refs.alert.open();
      //  return;
      //}


      //if (
      //  this.archivo_autorizacion_pdf &&
      //  this.archivo_autorizacion_pdf.type !== "application/pdf"
      //) {
      //  this.$refs.alert.setMessage(
      //    "",
      //    "El documento de autorización debe ser PDF."
      //  );
      //  this.$refs.alert.open();
      //  return;
      //}

      // Antes de guardar
      if (this.aplicaDocumentoAutorizacion) {
        const valor = this.archivo_autorizacion_pdf; // puede ser string, File o null

        const esNuevo = this.editedItem.id_puesto == null;
        const esString = typeof valor === "string";
        const esFile = valor instanceof File;
        const tieneNombreGuardado = esString && valor.trim() !== "";

        // --- CASO: CREACIÓN ---
        if (esNuevo) {
          // Debe traer forzosamente un File PDF
          if (!esFile) {
            this.$refs.alert.setMessage(
              "",
              "Es necesario un documento de autorización en formato PDF."
            );
            this.$refs.alert.open();
            return;
          }

          if (valor.type !== "application/pdf") {
            this.$refs.alert.setMessage(
              "",
              "El documento de autorización debe ser PDF."
            );
            this.$refs.alert.open();
            return;
          }
        }
        // --- CASO: EDICIÓN ---
        else {
          // Si no hay nombre guardado y tampoco subieron un File, hay que exigir PDF
          if (!tieneNombreGuardado && !esFile) {
            this.$refs.alert.setMessage(
              "",
              "Es necesario un documento de autorización en formato PDF."
            );
            this.$refs.alert.open();
            return;
          }

          // Si subieron un File nuevo, validar tipo
          if (esFile && valor.type !== "application/pdf") {
            this.$refs.alert.setMessage(
              "",
              "El documento de autorización debe ser PDF."
            );
            this.$refs.alert.open();
            return;
          }
        }
      }

      this.loading_save = true;

      this.editedItem.idiomas = this.editedItem.idiomas.map((item, index) => ({
        ...item,
        posicion: index + 1
      }));

      this.editedItem.conocimientos_requeridos = this.editedItem.conocimientos_requeridos.map((item, index) => ({
        ...item,
        posicion: index + 1
      }));

      this.editedItem.competencias = this.editedItem.competencias.map((item, index) => ({
        ...item,
        posicion: index + 1
      }));

      this.editedItem.equipo_resguardo = this.editedItem.equipo_resguardo.map((item, index) => ({
        ...item,
        posicion: index + 1
      }));

      this.editedItem.kpis = this.editedItem.kpis.map((item, index) => ({
        ...item,
        posicion: index + 1
      }));

      try {
        if (this.editedItem.id_puesto == null) {
          var response = await axios.post("/RecursosHumanos/CrearPuesto", this.editedItem);
          this.editedItem.id_puesto = response.data;
        } else {
          await axios.put(`/RecursosHumanos/EditarPuesto/${this.editedItem.id_puesto}`, this.editedItem);
        }

        if (this.archivo_autorizacion_pdf && typeof this.archivo_autorizacion_pdf !== 'string') {
          const form = new FormData();
          form.append("archivo_autorizacion_pdf", this.archivo_autorizacion_pdf); // el input file normalmente es un array

          await axios.post(
            `/RecursosHumanos/CargarArchivoAutorizacion/${this.editedItem.id_puesto}`,
            form,
            {
              headers: {
                "Content-Type": "multipart/form-data"
              }
            }
          );
        }
      } catch (error) {
        console.log(error)
      }
      finally {
        this.loading_save = false;
      }

      this.closeDialogAddEdit();
      this.getItems();
    },

    openDialogDelete(edit_item) {
      this.editedItem = JSON.parse(JSON.stringify(edit_item));
      this.dialogDelete = true;
    },

    closeDialogDelete() {
      this.editedItem = JSON.parse(JSON.stringify(this.defaultEditedItem));
      this.dialogDelete = false;
    },

    saveDialogDelete() {
      this.$refs.alert.setMessage(
        "Info",
        "Aún no hay endpoint de eliminación para Puestos. Implementa DELETE para enlazarlo."
      );
      this.$refs.alert.open();
    },

    // =========================
    // Requisitos hijo (sin cambios funcionales)
    // =========================
    openDialogRequisitos(edit_item) {
      this.loadingRequirements = true;
      this.requisitosDialogOpen = true;

      axios
      .get(`/RecursosHumanos/DetallePuesto/${edit_item.id_puesto}`)
      .then(response => {
        this.editedItem = response.data;
      })
      .catch(error => {
        console.log(error);
      })
      .finally(() => {
        this.loadingRequirements = false;
      })
    },

    async onRequisitosSave(requisitosActualizados) {
      this.loadingRequisitosDialogOpen = true;

      const idx = this.items.findIndex(
        (x) => x.id_puesto === this.editedItem.id_puesto
      );
      if (idx >= 0) {
        const nuevo = JSON.parse(JSON.stringify(this.items[idx]));
        nuevo.expediente_requisitos = requisitosActualizados;
        this.$set(this.items, idx, nuevo);
      }

      this.loadingRequisitosDialogOpen = false;

      this.$refs.alert.setMessage(
        "Info",
        "Aún no hay endpoint para guardar requisitos. Implementa el servicio y lo enlazo."
      );
      this.$refs.alert.open();
    },
  },
};
</script>

<style scoped>
.drag-handle {
  padding: 4px;
}
</style>
